import {styled, TextField, TextFieldProps} from "@mui/material";

export const StyledTextField = styled((props: TextFieldProps) => (
    <TextField {...props} />
))(({theme}) => ({
    ".Mui-focused.css-30wkfs-MuiInputBase-root-MuiInput-root:after": {
        borderBottom: "2px solid " + theme.palette.accent.main
    }
}));